<template>
  <div id="ovf">
    <v-footer color="primary lighten-1" padless>
      <v-row justify="center" no-gutters>
        <div id="footer">
          <v-btn
            v-for="link in links"
            :key="link"
            color="white"
            text
            rounded
            class="my-2"
          >
            {{ link }}
          </v-btn>
        </div>
        <v-col class="primary lighten-2 py-4 text-center white--text" cols="12">
          {{ new Date().getFullYear() }} — <strong>Morris Anthony</strong>
        </v-col>
      </v-row>
    </v-footer>
  </div>
</template>
<style>
#footer {
  display: flex;
  justify-content: center;
}
#ovf {
  padding-top: 315px;
  overflow: hidden;
}
</style>

<script>
export default {
  data: () => ({
    links: ["He", "Login", "Contact"],
  }),
};
</script>
